import actions from '@/core/store/bpm/actions'

export default {
	actions,
}
